<script setup lang="ts">
import { CalendarEvent } from "@/ts/stores/event";

interface Props {
    event: CalendarEvent;
}

defineProps<Props>();
</script>

<template>
    <a target="_blank" rel="noopener" :href="event.acf.media.flickr_album_id" class="group flex w-full flex-col">
        <div class="relative mb-6 w-full overflow-hidden">
            <div class="relative pt-[62.925170068%]">
                <img :src="event.acf.media.thumbnail.url" class="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-300 group-hover:scale-110" :alt="event.post_title" />
            </div>
        </div>
        <div class="flex flex-col justify-between gap-5">
            <p class="font-heading text-40 font-[690] uppercase line-clamp-1 [font-stretch:_190%] md:text-48 xl:text-40" v-html="event.post_title"></p>
            <div class="flex flex-wrap items-start gap-4 lg:items-center">
                <span class="btn btn-pink">
                    Bekijk het album
                    <svg-vue icon="arrow" class="ml-[.625rem] h-6 w-auto"></svg-vue>
                </span>
            </div>
        </div>
    </a>
</template>
